import { Component, ViewChild,AfterViewInit,ElementRef,Output,EventEmitter,Input } from '@angular/core';
import {WsService} from '../../utils/network/ws.service';
import {RecordingManagerService} from '../services/recording/recording-manager.service';
import {OnRecording} from '../services/recording/recording-manager';
import {Modal} from 'ng2-modal';
import {WbService} from '../wb.service';
import {environment} from '../../../environments/environment';
@Component({
  selector: "dskl-tools",
  templateUrl: 'tools.component.html',
 // providers: [WsService]

})
export class ToolsComponent implements AfterViewInit{
  
  @Input() recording=false;
  @Input() peers=[];
  @Output() onMaterials = new EventEmitter();
  @Input() pageId = null;
  @Input() board;
  @ViewChild("shareScreenModal") shareScreenModal: Modal;

  constructor(private wsService: WsService, private wbService: WbService, private recordingManagerService: RecordingManagerService){

  }
  ngAfterViewInit(){

  }
  hasContentModule(){
    return environment.contentModule && !this.wbService.isDemo()
  }
  onMaterialsClicked(){
    console.log("Cliecked on materials1")
    this.onMaterials.emit({});
  }
  onClicked() {
    console.log("Clicked on bytton ")
  }
  open(){
    
    
  }
  isRecording(){
    return this.demoRecording || this.recordingManagerService.isRecording();
  }
  demoRecording = false;
  onRecording(){
    if (this.wbService.isDemo()){
      this.demoRecording = !this.demoRecording;
    }else{
      this.recordingManagerService.switchRecording();
    }  
  }
}



// WEBPACK FOOTER //
// /app/src/app/wb/tools/tools.component.ts